<template>
  <div class="home">
    <div class="feedback-form" style="padding: 20px">
      <h2>用户评价</h2>
      <div class="satisfaction">
        <label>满意度：</label>
        <div class="rating-options">
          <button v-for="option in ratingOptions" :key="option.value"
                  :class="{ active: selectedRating === option.value }" @click="selectRating(option.value)">
            {{ option.label }}
          </button>
        </div>
      </div>
      <div class="comment">
        <label>评论：</label>
        <textarea v-model="userComment" class="comment-textarea" placeholder="请在此处输入您的评论（最多150个字）" maxlength="150" />
      </div>
      <button class="submit-btn" @click="submitFeedback" :disabled="!isFormValid">提交评价</button>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      VUE_APP_API_URL: process.env.VUE_APP_API_URL,
      ratingOptions: [{
        value: "非常满意",
        label: "非常满意"
      }, {
        value: "满意",
        label: "满意"
      }, {
        value: "一般",
        label: "一般"
      }, {
        value: "不满意",
        label: "不满意"
      }, {
        value: "非常不满意",
        label: "非常不满意"
      }],
      selectedRating: null,
      userComment: ""
    };
  },
  computed: {
    isFormValid() {
      return this.selectedRating !== null;
    }
  },
  props: {
    id: {
      type: Object,
      required: true
    }
  },
  methods: {
    selectRating(rating) {
      this.selectedRating = rating;
    },
    submitFeedback() {
      if (!this.isFormValid) {
        return;
      }
      axios.post(`${this.VUE_APP_API_URL}/open/complaint`, {
        "id": this.id,
        "content": this.userComment,
        "satisfaction": this.selectedRating,
        "type": "1"
      })
        .then(response => {
          if (response.data.code == 200) {
            this.selectedRating = null;
            this.userComment = "";
            alert(response.data.msg);
          } else {
            alert("提交失败");
          }
        });
    }
  }
};
</script>
<style scoped>
.user-info h2, .feedback-form h2 {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.satisfaction, .comment {
  margin: 20px 0;
}

.rating-options {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.rating-options button {
  padding: 8px 15px;
  border: 1px solid #ddd;
  background: #f5f5f5;
  border-radius: 4px;
  cursor: pointer;
}

.rating-options button.active {
  background: #1890ff;
  color: white;
  border-color: #1890ff;
}

.comment textarea {
  width: 100%;
  min-height: 100px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 10px;
  resize: vertical;
}

.submit-btn {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.submit-btn:hover:not(:disabled) {
  background: #40a9ff;
}

.comment-textarea {
  width: 100%;
  min-height: 150px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  resize: vertical;
}

.comment-textarea:focus {
  outline: none;
  border-color: #409eff;
  box-shadow: 0 0 5px rgba(64, 158, 255, 0.3);
}
</style>
